import type { ReactStoryblokComponent } from "types/storyblok";
import type { OurTeamProps } from "modules/sections/OurTeam";
import { OurTeam } from "modules/sections/OurTeam";

const OurTeamSectionAdapter = ({
  blok: { subHeading, title, subtitle, cards },
  sbEditable,
}: ReactStoryblokComponent<OurTeamProps>) => (
  <OurTeam subHeading={subHeading} title={title} subtitle={subtitle} cards={cards} sbEditable={sbEditable} />
);
export default OurTeamSectionAdapter;
